import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { transformBirthdayDocument } from 'shell/utils/consult-person/response-transformer/registry-office/transform-birthday-document';
import { transformGenerality } from 'shell/utils/consult-person/response-transformer/registry-office/generality';
import { transformFamilyCoexistence } from 'shell/utils/consult-person/response-transformer/family/family-coexistence';
import { initialValues } from 'subscription/constants/subscription-birth';
import { transformParenthood } from 'shell/utils/consult-person/response-transformer/registry-office/parenthood';
import { transformCitizenship } from 'shell/utils/consult-person/response-transformer/registry-office/citizenship';
import { ParenthoodVM } from 'shell/view-models/parenthood';
import { transformAddressForeign } from './address-foreign.transformer';
import { SubscriptionTransferOtherMunicipalityFormVM } from 'subscription/view-models/subscription-transfer-other-municipality';

export const transformerSubscriptionTransferOtherMunicipalityData = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>,
  isCohabitation?: boolean,
  isTransferNew?: boolean
): SubscriptionTransferOtherMunicipalityFormVM => {
  const [person] = response.data?.payload?.risposta3002OK?.listaSoggetti?.datiSoggetto || [];

  const birthdayDocument = transformBirthdayDocument(person);

  const generality = transformGenerality(person);

  const familyCoexistence = transformFamilyCoexistence(person) || {};

  const addressForeign = transformAddressForeign(person);

  const parenthood = transformParenthood(person) || [];

  const citizenship = transformCitizenship(person) || [];

  let generalityPerson = {};

  if (isTransferNew) {
    generalityPerson = generality || {};
  }

  let birthdayDocumentNew = {};

  if (isTransferNew) {
    birthdayDocumentNew = birthdayDocument || {};
  }

  let paternityNew: ParenthoodVM | undefined = undefined;

  if (isTransferNew) {
    paternityNew = parenthood[0] || undefined;
  }

  let maternityNew: ParenthoodVM | undefined = undefined;

  if (isTransferNew) {
    maternityNew = parenthood[1] || undefined;
  }

  let citizenshipNew = {};

  if (isTransferNew) {
    citizenshipNew = citizenship[0] || {};
  }

  return {
    ...initialValues,
    type: person?.famigliaConvivenza?.tipoScheda,
    birthdayDocument: birthdayDocumentNew,
    citizenship: citizenshipNew,
    // citizenship: {
    //   validity: generality?.birthDate,
    // },
    // editDataControl,
    addressForeign,
    familyCoexistence: {
      ...initialValues.familyCoexistence,
      isCohabitation,
      // solamente dati non editabili
      municipalityIdentifier: familyCoexistence?.municipalityIdentifier || undefined,
      codeIstat: familyCoexistence?.codeIstat || undefined,
      identifierAnpr: familyCoexistence?.identifierAnpr || undefined,
      originDate: familyCoexistence?.originDate || undefined,
      familyAire: familyCoexistence?.familyAire || undefined,
      reasonConstitution: familyCoexistence?.reasonConstitution || undefined,
      cohabitingFamily: familyCoexistence?.cohabitingFamily || undefined,
      handlingType: familyCoexistence?.handlingType || undefined,
      especiallyCoexistence: familyCoexistence?.especiallyCoexistence || undefined,
      especiallyCoexistenceDescription:
        familyCoexistence?.especiallyCoexistenceDescription || undefined,
      nameCoexistence: familyCoexistence?.nameCoexistence || undefined,
    },
    generality: {
      ...initialValues.generality,
      ...generalityPerson,
      aire: isCohabitation ? 'N' : !generality?.aire ? 'N' : generality?.aire,
    },
    fatherhood: paternityNew,
    // generality: {
    //...initialValues.generality,
    // ...(generality || {}),
    //},
    motherhood: maternityNew,
    // person: personVM || undefined,
  };
};
